module.exports = __webpack_public_path__ + "static/media/screenshot.f519b6c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/cookies/screenshot.png
// module id = 955
// module chunks = 21